function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74DAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0070DF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "path-2",
  x: 0,
  y: 0,
  width: 64,
  height: 64,
  rx: 32
}), /*#__PURE__*/React.createElement("filter", {
  x: "-128.9%",
  y: "-82.0%",
  width: "357.8%",
  height: "357.8%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 30,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 22.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.329350825 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "10.10\\u6700\\u7EC8",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5F00\\u53D1\\u8005\\u670D\\u52A1\\u5E73\\u53F0-10.14",
  transform: "translate(-399.000000, -1306.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-16",
  transform: "translate(-92.000000, 1273.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u7F16\\u7EC4-3",
  transform: "translate(457.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "9\\u5927\\u670D\\u52A1",
  transform: "translate(79.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u77E9\\u5F62"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  x: 14,
  y: 14,
  width: 36,
  height: 36
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.7,33.125 L43.7,29.9 C45.95,29.15 47.225,26.75 46.475,24.425 C45.725,22.175 43.325,20.9 41,21.65 C40.55,21.8 40.1,22.025 39.725,22.325 L36.2,20.375 C36.725,18.05 35.3,15.725 32.975,15.125 C30.65,14.525 28.325,16.025 27.725,18.35 C27.575,19.025 27.575,19.7 27.725,20.3 L24.2,22.4 C22.325,20.9 19.625,21.2 18.125,23.075 C16.625,24.95 16.925,27.65 18.8,29.15 C19.175,29.45 19.55,29.675 20,29.825 L20,33.05 C17.675,33.725 16.4,36.125 17.075,38.45 C17.75,40.775 20.15,42.05 22.475,41.375 C23.15,41.15 23.825,40.775 24.275,40.25 L27.65,42.2 C27.275,44.525 28.85,46.775 31.175,47.15 C33.5,47.525 35.75,45.95 36.125,43.625 C36.2,43.1 36.2,42.575 36.125,42.05 L39.2,40.325 C40.925,41.975 43.625,41.975 45.35,40.25 C47.075,38.525 47,35.825 45.275,34.1 C44.975,33.725 44.375,33.35 43.7,33.125 Z M44.45,25.85 C44.45,26.975 43.475,27.95 42.35,27.95 C41.225,27.95 40.25,26.975 40.25,25.85 C40.25,24.725 41.15,23.75 42.35,23.75 C43.55,23.75 44.45,24.65 44.45,25.85 Z M21.575,23.75 C22.7,23.75 23.675,24.65 23.675,25.85 C23.675,26.975 22.775,27.95 21.575,27.95 C20.375,27.95 19.475,27.05 19.475,25.85 C19.55,24.65 20.45,23.75 21.575,23.75 L21.575,23.75 Z M32.075,45.05 C30.95,45.05 29.975,44.15 29.975,42.95 C29.975,41.825 30.875,40.85 32.075,40.85 C33.2,40.85 34.175,41.75 34.175,42.95 C34.175,44.15 33.275,45.05 32.075,45.05 Z M32.075,38.675 C30.8,38.675 29.6,39.275 28.775,40.25 L25.55,38.375 C26.15,36.05 24.8,33.725 22.475,33.125 L22.4,33.125 L22.4,30.125 C24.725,29.75 26.3,27.5 25.925,25.1 C25.85,24.8 25.775,24.575 25.7,24.275 L28.925,22.4 C30.575,24.125 33.275,24.2 35,22.625 L35.225,22.4 L38.375,24.125 C37.475,26.3 38.525,28.85 40.7,29.75 C40.925,29.825 41.15,29.9 41.45,29.975 L41.45,32.975 C39.125,33.5 37.625,35.75 38.15,38.075 C38.15,38.15 38.15,38.225 38.225,38.3 L35.3,40.025 C34.475,39.125 33.275,38.675 32.075,38.675 Z",
  id: "\\u5F62\\u72B6",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

function SvgGroup11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154px",
    height: "154px",
    viewBox: "0 0 154 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9\u5927\u670D\u52A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11);
export default __webpack_public_path__ + "static/media/group1_1.395871ce.svg";
export { ForwardRef as ReactComponent };